// Import Home component
import About from "./components/aboutus";
import Contact from "./components/contact";
import Footer from "./components/footer";
// or Switch in older versions
import Header from "./components/header";
import Home from "./components/home";
import PrivacyPolicy from "./components/privacypolicy";
import ProductPage from "./components/productpage";
import Sanitary from "./components/sanitary";
import SanitaryPage from "./components/sanitarypage";
import Shop from "./components/shopcatalog";
import TermsConditions from "./components/termsconditions";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

// Import your App.css file

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:productId" element={<ProductPage />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/sanitary-shop" element={<Sanitary />} />
          <Route path="/sanitary/:productId" element={<SanitaryPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
